import { Fragment, jsx } from "react/jsx-runtime";
import { composeRefs } from "@tamagui/compose-refs";
import { isWeb } from "@tamagui/constants";
import { Children, cloneElement, forwardRef, isValidElement } from "react";
const Slot = forwardRef(function Slot2(props, forwardedRef) {
  const { children, ...slotProps } = props;
  if (isValidElement(children)) {
    const childProps = {
      ...mergeSlotProps(children, slotProps),
      ref: composeRefs(forwardedRef, children.ref)
    };
    return cloneElement(children, childProps);
  }
  return Children.count(children) > 1 ? Children.only(null) : null;
});
const Slottable = ({ children }) => {
  return /* @__PURE__ */ jsx(Fragment, { children });
};
const pressMap = isWeb ? {
  onPress: "onClick",
  onPressOut: "onMouseUp",
  onPressIn: "onMouseDown"
} : {};
function mergeSlotProps(child, slotProps) {
  const childProps = child.props;
  const overrideProps = { ...childProps };
  const isHTMLChild = typeof child.type === "string";
  if (isHTMLChild) {
    for (const key in pressMap) {
      if (key in slotProps) {
        slotProps[pressMap[key]] = slotProps[key];
        delete slotProps[key];
      }
    }
  }
  for (let propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    if (isHTMLChild && pressMap[propName]) {
      propName = pressMap[propName];
      delete overrideProps[propName];
    }
    const isHandler = handleRegex.test(propName);
    if (isHandler) {
      overrideProps[propName] = mergeEvent(childPropValue, slotPropValue);
    } else if (propName === "style") {
      overrideProps[propName] = { ...slotPropValue, ...childPropValue };
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return { ...slotProps, ...overrideProps };
}
const handleRegex = /^on[A-Z]/;
function mergeEvent(a, b) {
  return (...args) => {
    a == null ? void 0 : a(...args);
    b == null ? void 0 : b(...args);
  };
}
export {
  Slot,
  Slottable,
  mergeEvent
};
//# sourceMappingURL=Slot.js.map
